import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20interior%20with%20large%20projection%20screen%20displaying%20vibrant%20colorful%20abstract%20light%20patterns%2C%20luxurious%20red%20velvet%20seats%2C%20warm%20ambient%20golden%20lighting%2C%20dramatic%20atmosphere%2C%20professional%20commercial%20photography%2C%20rich%20contrast%20between%20dark%20shadows%20and%20warm%20highlights&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="精品视频平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight max-w-3xl">
          {t('hero_title')}
        </h1>
        <p className="text-background-200 text-sm md:text-lg mt-4 md:mt-6 max-w-2xl leading-relaxed">
          {t('hero_subtitle')}
        </p>
        <div className="flex items-center gap-4 mt-8 md:mt-10">
          <Link
            to="/category/dianying"
            className="px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors text-sm md:text-base whitespace-nowrap"
          >
            {t('hero_cta')}
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 rounded-full border-2 border-background-50/40 text-background-50 font-medium hover:bg-background-50/10 transition-colors text-sm md:text-base whitespace-nowrap"
          >
            {t('learn_more')}
          </Link>
        </div>

        <div className="flex items-center gap-8 mt-10 md:mt-14">
          <div className="text-center">
            <p className="text-background-50 text-xl md:text-2xl font-bold font-heading">5000万+</p>
            <p className="text-background-300 text-xs mt-1">服务用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-background-50 text-xl md:text-2xl font-bold font-heading">10万+小时</p>
            <p className="text-background-300 text-xs mt-1">精彩内容</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-background-50 text-xl md:text-2xl font-bold font-heading">200+</p>
            <p className="text-background-300 text-xs mt-1">合作方</p>
          </div>
        </div>
      </div>
    </section>
  );
}